import { jsxs, jsx } from "react/jsx-runtime";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
const ErrorFallback = ({
  error,
  resetErrorBoundary
}) => {
  let source = null;
  try {
    const fileStr = error.stack?.split("\n")[1]?.replace(/^\s+at\s+/, "");
    if (fileStr) {
      const file = new URL(fileStr);
      const t = file.searchParams.get("t") || "";
      const [hash, line, column] = t.split(":");
      source = {
        file: file.pathname,
        line: line || "",
        column: column || "",
        hash: hash || ""
      };
    }
  } catch (e) {
    console.error("Error parsing error stack:", e);
  }
  return /* @__PURE__ */ jsxs(Box, { component: Paper, elevation: 3, sx: {
    p: 4,
    textAlign: "center",
    bgcolor: "#AEAEAE",
    color: "white",
    borderRadius: 2,
    maxWidth: 400,
    margin: "auto",
    mt: 6
  }, children: [
    /* @__PURE__ */ jsx(ReportProblemRoundedIcon, { sx: {
      fontSize: 48,
      color: "#f44336",
      mb: 2
    } }),
    /* @__PURE__ */ jsx(Typography, { variant: "h6", gutterBottom: true, children: "Something went wrong" }),
    /* @__PURE__ */ jsx(Typography, { variant: "body2", sx: {
      mb: 3
    }, children: error.message || "An unexpected error occurred." }),
    source && /* @__PURE__ */ jsxs(Typography, { variant: "caption", sx: {
      mb: 3
    }, children: [
      /* @__PURE__ */ jsx("strong", { children: "File:" }),
      " ",
      source.file,
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx("strong", { children: "Line:" }),
      " ",
      source.line,
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx("strong", { children: "Column:" }),
      " ",
      source.column,
      /* @__PURE__ */ jsx("br", {})
    ] }),
    resetErrorBoundary && /* @__PURE__ */ jsx(Button, { variant: "contained", color: "primary", onClick: resetErrorBoundary, sx: {
      mt: 2
    }, children: "Try Again" })
  ] });
};
export {
  ErrorFallback as default
};
